import { useEffect, useMemo, useState } from "react";
import api from "@/lib/api";

export const fmtDay = (d) => new Date(`${d}T12:00:00`).toLocaleDateString("en-CA", { weekday: "short", month: "short", day: "numeric" });

// Step 1 of the demo page: pick a day and time. Booking happens after the form below is submitted.
export function DemoSlotPicker({ picked, onPick, reloadKey }) {
  const [slots, setSlots] = useState(null);
  const [day, setDay] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let live = true;
    api.get("/demo/slots?days=14").then((r) => {
      if (!live) return;
      setSlots(r.data.slots); setError(null);
      setDay((d) => (d && r.data.slots.some((s) => s.local_date === d) ? d : r.data.slots[0]?.local_date || null));
    }).catch(() => live && setError("Could not load available times."));
    return () => { live = false; };
  }, [reloadKey]);

  const days = useMemo(() => [...new Set((slots || []).map((s) => s.local_date))], [slots]);
  const daySlots = (slots || []).filter((s) => s.local_date === day);

  if (error && !slots) return <p role="alert" className="text-sm text-rose-600" data-testid="demo-times-error">{error}</p>;
  if (!slots) return <p className="text-sm text-slate-500" data-testid="demo-times-loading">Loading available times…</p>;
  return (
    <div data-testid="demo-slot-picker">
      <div className="flex flex-wrap gap-4 text-sm text-slate-700">
        <span data-testid="demo-duration">Demo duration: <strong>20 minutes</strong></span>
        <span data-testid="demo-hours">Available hours: <strong>8:30 AM – 6:00 PM Eastern Time</strong></span>
      </div>
      <p className="text-xs text-slate-500 mt-1">Available times are based on Cyannect's Eastern Time scheduling hours. All times below are shown in Eastern Time (America/Toronto).</p>
      {days.length === 0 && <p className="mt-6 text-sm text-slate-600" data-testid="demo-no-slots">No times are available in the next two weeks. Please email sales@cyannect.com.</p>}
      <div className="flex gap-2 overflow-x-auto mt-5 pb-2" role="tablist" aria-label="Choose a day">
        {days.map((d) => (
          <button key={d} type="button" role="tab" aria-selected={d === day} onClick={() => { setDay(d); onPick(null); }} data-testid={`demo-day-${d}`}
            className={`shrink-0 px-4 py-2 rounded-xl text-sm border transition-colors ${d === day ? "bg-slate-900 text-white border-slate-900" : "border-slate-300 hover:border-slate-900"}`}>{fmtDay(d)}</button>
        ))}
      </div>
      <div className="grid grid-cols-3 sm:grid-cols-5 gap-2 mt-4">
        {daySlots.map((s) => (
          <button key={s.start_utc} type="button" onClick={() => onPick(s)} aria-pressed={picked?.start_utc === s.start_utc}
            data-testid={`demo-time-${s.start_utc}`}
            className={`px-3 py-2 rounded-xl text-sm border transition-colors ${picked?.start_utc === s.start_utc ? "bg-cyan-600 text-white border-cyan-600" : "border-slate-300 hover:border-cyan-600"}`}>
            {s.local_time} <span className="text-[10px] opacity-70">{s.tz_abbrev}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
